<template>
    <div class="preview-box frequency-set-preview">
        <ul>
            <li>
                <label>Bandwidth</label>
                <span data-test-id="freq-preview-bandwidth">{{ bandwidthDisplay }}</span>
            </li>
            <li>
                <label>Max Power</label>
                <span data-test-id="freq-preview-max-power">{{ frequencySet.max_power }}</span>
            </li>
            <li>
                <label>Channels</label>
                <ul
                    v-if="frequencySet"
                    data-test-id="freq-preview-channels"
                    :class="{ collapsed: collapsed }"
                >
                    <li
                        v-for="channel in frequencySet.channels"
                        :key="channel.id"
                        :title="`${channel.type}: ${channel.frequency}`"
                    >
                        {{ channel.frequency }}
                        <span
                            class="channel-type"
                            :class="channel.type"
                            >{{ channel.type }}</span
                        >
                    </li>

                    <li
                        v-if="frequencySet.channels.length > 4"
                        class="toggle-display-all"
                    >
                        <a
                            href="#"
                            data-test-id="freq-preview-show-all"
                            @click.prevent="getAllItems()"
                            >{{ toggleText }}</a
                        >
                    </li>
                </ul>
            </li>
        </ul>
    </div>
</template>

<script>
import frequencySetSpacing from '@/mixins/frequencySetSpacing'

export default {
    mixins: [frequencySetSpacing],

    props: {
        frequencySet: {
            type: Object,
            required: true,
        },
    },

    data() {
        return {
            collapsed: true,
        }
    },

    computed: {
        toggleText() {
            return this.collapsed ? `Show All (${this.frequencySet.channels.length})` : 'Collapse'
        },
        bandwidthDisplay() {
            const bandwidth = this.bandwidthChoices.find(({ value }) => value === this.frequencySet.bandwidth)
            return bandwidth ? bandwidth.value : null
        },
    },

    methods: {
        getAllItems() {
            this.collapsed = !this.collapsed
        },
    },
}
</script>

<style lang="scss" scoped>
.frequency-set-preview {
    .channel-type.Control {
        color: #75bac4;
    }

    .channel-type.Data {
        color: #ffb571;
    }

    .collapsed li:nth-of-type(n + 5) {
        display: none;
    }

    .toggle-display-all {
        display: list-item !important;
    }
}
</style>
